import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, HeadphonesIcon, BrainIcon, ZapIcon } from 'lucide-react';
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-bg)'
  }} data-id="element-235">
      <div className="max-w-2xl mx-auto" data-id="element-236">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="mb-10" data-id="element-237">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-238">
            El mecanismo — por qué esto es diferente
          </p>

          <h2 className="text-3xl md:text-4xl font-black mb-6 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-239">
            Crecimiento AudioPro no es un curso más.
          </h2>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-240">
            No es una colección de frases inspiracionales empaquetadas en PDF.
          </p>

          <p className="text-lg leading-relaxed mb-10" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-241">
            Es una{' '}
            <strong style={{
            color: 'var(--color-text)'
          }} data-id="element-242">
              biblioteca de reprogramación mental
            </strong>{' '}
            — diseñada específicamente para personas que ya saben que necesitan
            cambiar, pero que han descubierto que el conocimiento solo no es
            suficiente.
          </p>

          <div className="py-6 px-8 mb-12 rounded-sm" style={{
          background: 'var(--color-surface)',
          borderLeft: '4px solid var(--color-accent)'
        }} data-id="element-243">
            <p className="text-xl italic leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-text)'
          }} data-id="element-244">
              "El subconsciente no aprende leyendo. Aprende por repetición,
              audio, emoción y estado alterado de consciencia."
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="space-y-6 mb-10" data-id="element-245">
          <div className="flex items-start gap-5 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-246">
            <div className="w-12 h-12 rounded-sm flex items-center justify-center flex-shrink-0" style={{
            background: 'rgba(78,205,196,0.1)',
            border: '1px solid var(--color-accent)'
          }} data-id="element-247">
              <BookOpenIcon className="w-6 h-6" style={{
              color: 'var(--color-accent)'
            }} data-id="element-248" />
            </div>
            <div data-id="element-249">
              <p className="font-bold mb-2" style={{
              color: 'var(--color-text)'
            }} data-id="element-250">
                Libros Digitales
              </p>
              <p className="text-base leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-251">
                Instalan marcos mentales claros y directos. No teoría. Sistemas
                aplicables.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-5 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-252">
            <div className="w-12 h-12 rounded-sm flex items-center justify-center flex-shrink-0" style={{
            background: 'rgba(78,205,196,0.1)',
            border: '1px solid var(--color-accent)'
          }} data-id="element-253">
              <HeadphonesIcon className="w-6 h-6" style={{
              color: 'var(--color-accent)'
            }} data-id="element-254" />
            </div>
            <div data-id="element-255">
              <p className="font-bold mb-2" style={{
              color: 'var(--color-text)'
            }} data-id="element-256">
                Audiolibros Estratégicos
              </p>
              <p className="text-base leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-257">
                Trabajan mientras caminas, manejas, entrenas. Tu mente
                consciente está ocupada — tu subconsciente está absorbiendo.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-5 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-258">
            <div className="w-12 h-12 rounded-sm flex items-center justify-center flex-shrink-0" style={{
            background: 'rgba(78,205,196,0.1)',
            border: '1px solid var(--color-accent)'
          }} data-id="element-259">
              <BrainIcon className="w-6 h-6" style={{
              color: 'var(--color-accent)'
            }} data-id="element-260" />
            </div>
            <div data-id="element-261">
              <p className="font-bold mb-2" style={{
              color: 'var(--color-text)'
            }} data-id="element-262">
                Meditaciones Estratégicas
              </p>
              <p className="text-base leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-263">
                No son para relajarte. Son para penetrar los sistemas de
                creencias que viven debajo de tu pensamiento racional.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-5 p-6 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-264">
            <div className="w-12 h-12 rounded-sm flex items-center justify-center flex-shrink-0" style={{
            background: 'rgba(78,205,196,0.1)',
            border: '1px solid var(--color-accent)'
          }} data-id="element-265">
              <ZapIcon className="w-6 h-6" style={{
              color: 'var(--color-accent)'
            }} data-id="element-266" />
            </div>
            <div data-id="element-267">
              <p className="font-bold mb-2" style={{
              color: 'var(--color-text)'
            }} data-id="element-268">
                Protocolos Mentales 5–20 min
              </p>
              <p className="text-base leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-269">
                Crean consistencia sin depender de motivación — porque están
                diseñados para el cerebro real, no para el cerebro ideal.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.7,
        duration: 0.6
      }} data-id="element-270">
          <div className="py-6 px-8 text-center rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-accent)'
        }} data-id="element-271">
            <p className="text-2xl font-black" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-accent)'
          }} data-id="element-272">
              No es contenido. Es intervención.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}